/**
 * Path relativo canónico “arma tu equipo” (meta og:url, etc.).
 * Formato: arma-tu-equipo-{slug}/{encodeURIComponent(userId)}
 */

export function buildArmaTuEquipoPathWithUser(teamSlug, userId) {
  if (!teamSlug || userId == null || userId === "") return null;
  return `arma-tu-equipo-${teamSlug}/${encodeURIComponent(String(userId))}`;
}

/**
 * URL absoluta del embed (front-handler) para **armar** el 11.
 * Ruta: `/futbolTeam/{prod}/{teamSlug}`
 */
export function buildArmaTuEquipoEditorIframeUrl(iframeBase, teamSlug, prod = "clarin") {
  if (!iframeBase || !teamSlug) return "";
  const base = String(iframeBase).replace(/\/$/, "");
  return `${base}/futbolTeam/${encodeURIComponent(prod)}/${encodeURIComponent(String(teamSlug))}`;
}

/**
 * URL absoluta del embed (front-handler) para la vista de solo lectura del 11 guardado.
 * Ruta: /futbolTeam/{prod}/arma-tu-equipo/{teamSlug}
 * (sin userId en la query — appendArmaTuEquipoParams lo agrega después)
 */
export function buildArmaTuEquipoLineupViewerUrl(iframeBase, teamSlug, userId, prod = "clarin") {
  if (!iframeBase || !teamSlug || userId == null || userId === "") return null;
  const base = String(iframeBase).replace(/\/$/, "");
  return `${base}/futbolTeam/${encodeURIComponent(prod)}/arma-tu-equipo/${encodeURIComponent(String(teamSlug))}`;
}

/**
 * Path en pagegrowler sin slash inicial: un solo segmento de ruta + userId en query.
 * Mejor compatibilidad con Lilax/TemplateBuilder que a veces no tienen “vista” para dos segmentos.
 * `docId` y `matchId` opcionales (misma convención que Olé / api-handler).
 */
export function buildArmaTuEquipoPublicPagePathWithUserInQuery(
  teamSlug,
  userId,
  teamQuery,
  docId,
  matchId,
) {
  if (!teamSlug || userId == null || userId === "") return null;
  const qs = new URLSearchParams();
  qs.set("userId", String(userId));
  qs.set(
    "team",
    teamQuery != null && teamQuery !== "" ? String(teamQuery) : String(teamSlug),
  );
  if (docId != null && String(docId).trim() !== "") {
    qs.set("docId", String(docId).trim());
  }
  if (matchId != null && String(matchId).trim() !== "") {
    qs.set("matchId", String(matchId).trim());
  }
  return `arma-tu-equipo-${teamSlug}?${qs.toString()}`;
}

/** Misma URL con slash inicial (router.replace en el sitio). */
export function buildArmaTuEquipoPublicPageAbsoluteWithUserInQuery(teamSlug, userId, teamQuery) {
  const p = buildArmaTuEquipoPublicPagePathWithUserInQuery(teamSlug, userId, teamQuery);
  return p ? `/${p}` : null;
}
